import { MagpieConnection } from 'magpie-lib/connection';
import { defineMessage, defineTopic } from 'magpie-lib/models';
import * as t from '../../utils/schema';
import { CollaborationSidebarAudience, CollaborationSidebarSessionId } from '../../utils/magpie';
const SessionIdSchema = t.literal(CollaborationSidebarSessionId);
export const ConfirmEditRepeatingTaskResult = defineMessage({
  type: 'confirmEditRepeatingTaskResult',
  payloadSchema: t.object({
    sessionId: t.optional(SessionIdSchema),
    updateTemplate: t.union(t.boolean, t.literal(null))
  })
});
export const RequestShowConfirmEditRepeatingTaskModal = defineMessage({
  type: 'requestShowConfirmEditRepeatingTaskModal',
  payloadSchema: t.object({
    sessionId: SessionIdSchema
  }),
  reply: ConfirmEditRepeatingTaskResult
});
export const RepeatingTaskConfirmTopic = defineTopic({
  name: 'RepeatingTaskConfirmTopic',
  messages: [RequestShowConfirmEditRepeatingTaskModal, ConfirmEditRepeatingTaskResult],
  audience: CollaborationSidebarAudience,
  enableRuntimeValidation: false
});
export const getRepeatingTaskConfirmTopic = () => MagpieConnection.get().forTopic(RepeatingTaskConfirmTopic);
export function requestShowConfirmEditRepeatingTaskModal(options) {
  const topic = getRepeatingTaskConfirmTopic();
  const message = RequestShowConfirmEditRepeatingTaskModal.create({
    sessionId: CollaborationSidebarSessionId
  });
  return topic.publish(message, options);
}